/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { LastProcessInformation } from '../models/last-process-information';
import { NewProjectModelField } from '../models/new-project-model-field';
import { ProjectModelField } from '../models/project-model-field';
import { ProjectModelFieldPartial } from '../models/project-model-field-partial';
import { ProjectModelFieldWithRelations } from '../models/project-model-field-with-relations';
import { UpdateMultipleProjectModelField } from '../models/update-multiple-project-model-field';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class ProjectModelFieldControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation projectModelFieldControllerCustomBulkUpdate
   */
  static readonly ProjectModelFieldControllerCustomBulkUpdatePath = '/project-model-fields/bulk-update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customBulkUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customBulkUpdate$Response(params?: {
    body?: UpdateMultipleProjectModelField
  }): Observable<StrictHttpResponse<ProjectModelField>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectModelFieldControllerService.ProjectModelFieldControllerCustomBulkUpdatePath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectModelField>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `customBulkUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customBulkUpdate(params?: {
    body?: UpdateMultipleProjectModelField
  }): Observable<ProjectModelField> {

    return this.customBulkUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectModelField>) => r.body as ProjectModelField)
    );
  }

  /**
   * Path part for operation projectModelFieldControllerCount
   */
  static readonly ProjectModelFieldControllerCountPath = '/project-model-fields/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectModelFieldControllerService.ProjectModelFieldControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation projectModelFieldControllerFindLatestChangeTimestamps
   */
  static readonly ProjectModelFieldControllerFindLatestChangeTimestampsPath = '/project-model-fields/latest-change-timestamps';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findLatestChangeTimestamps()` instead.
   *
   * This method doesn't expect any request body.
   */
  findLatestChangeTimestamps$Response(params?: {
  }): Observable<StrictHttpResponse<LastProcessInformation>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectModelFieldControllerService.ProjectModelFieldControllerFindLatestChangeTimestampsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LastProcessInformation>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findLatestChangeTimestamps$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findLatestChangeTimestamps(params?: {
  }): Observable<LastProcessInformation> {

    return this.findLatestChangeTimestamps$Response(params).pipe(
      map((r: StrictHttpResponse<LastProcessInformation>) => r.body as LastProcessInformation)
    );
  }

  /**
   * Path part for operation projectModelFieldControllerFindById
   */
  static readonly ProjectModelFieldControllerFindByIdPath = '/project-model-fields/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<ProjectModelField>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectModelFieldControllerService.ProjectModelFieldControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectModelField>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<ProjectModelField> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectModelField>) => r.body as ProjectModelField)
    );
  }

  /**
   * Path part for operation projectModelFieldControllerDeleteById
   */
  static readonly ProjectModelFieldControllerDeleteByIdPath = '/project-model-fields/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
    options?: any;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectModelFieldControllerService.ProjectModelFieldControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('options', params.options, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
    options?: any;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation projectModelFieldControllerUpdateById
   */
  static readonly ProjectModelFieldControllerUpdateByIdPath = '/project-model-fields/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: ProjectModelFieldPartial
  }): Observable<StrictHttpResponse<ProjectModelField>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectModelFieldControllerService.ProjectModelFieldControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectModelField>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: ProjectModelFieldPartial
  }): Observable<ProjectModelField> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectModelField>) => r.body as ProjectModelField)
    );
  }

  /**
   * Path part for operation projectModelFieldControllerFind
   */
  static readonly ProjectModelFieldControllerFindPath = '/project-model-fields';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ProjectModelFieldWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectModelFieldControllerService.ProjectModelFieldControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectModelFieldWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<ProjectModelFieldWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProjectModelFieldWithRelations>>) => r.body as Array<ProjectModelFieldWithRelations>)
    );
  }

  /**
   * Path part for operation projectModelFieldControllerCreate
   */
  static readonly ProjectModelFieldControllerCreatePath = '/project-model-fields';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewProjectModelField
  }): Observable<StrictHttpResponse<ProjectModelField>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectModelFieldControllerService.ProjectModelFieldControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectModelField>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewProjectModelField
  }): Observable<ProjectModelField> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectModelField>) => r.body as ProjectModelField)
    );
  }

}
